
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à La Rochelle dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à La Rochelle certifiée Google Partner, accompagne les entreprises rochelaises pour booster leur visibilité en ligne et capter de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à La Rochelle dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à La Rochelle certifiée Google Partner, accompagne les entreprises rochelaises pour booster leur visibilité en ligne et capter de nouveaux clients.",
        },
      ],
    };
  },
};
